import {createContext} from "react";

export const  TimerContext = createContext({})